import classNames from 'classnames'
import React from 'react'
import styles from './cta_button_group.module.css'
import { CtaButtonGroupProps } from './types'
import { DonateButton } from 'src/ppp/donate_button'
import { SharingGridButton } from 'src/shared'

export const CtaButtonGroup = ({
  shareUrl,
  hasStatusMessage,
  hideDonateButton,
  utmMedium,
  utmContent,
  onClickShareButton,
  trackingPageTitle,
  trackingId,
  ...sharedDonateButtonProps
}: CtaButtonGroupProps) => {
  return (
    <div
      className={classNames(styles.container, { [styles.wrappedContainer]: hasStatusMessage })}
      data-testid="ppp-cta-button-group"
    >
      <SharingGridButton
        shareUrl={shareUrl}
        platforms={['email', 'facebook', 'twitter', 'link', 'whatsapp', 'messenger']}
        modalHeader={i18n.t('projects.show.stats.share_modal_headline')}
        buttonLabel={i18n.t('projects.show.stats.share_button_sticky_label')}
        size="large"
        utmMedium={utmMedium}
        utmContent={utmContent}
        onClickShareButton={onClickShareButton}
        trackingPageTitle={trackingPageTitle}
        trackingId={trackingId}
      />
      {!hideDonateButton && <DonateButton buttonLocation="PPP Sticky" size="large" {...sharedDonateButtonProps} />}
    </div>
  )
}
